import { useEffect, useState } from 'react';

import entityApi from '/src/apis/entityApi';

const useFetchICEData = (id, endpoint, hasAccess) => {
    const [fetchDataError, setFetchDataError] = useState(null);
    const [restrictedProfileData, setRestrictedProfileData] = useState({});
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const fetchRestrictedProfileData = async () => {
            setIsLoading(true);
            try {
                if (!hasAccess) {
                    setRestrictedProfileData({});
                    setFetchDataError(null);
                    return;
                }

                const response = await entityApi.getRestrictedProfileData(id, endpoint);
                setRestrictedProfileData(response || {});
                setFetchDataError(null);
            } catch (error) {
                console.error('Failed to fetch restricted profile data:', error);
                setRestrictedProfileData({});
                setFetchDataError(error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchRestrictedProfileData();
    }, [id, endpoint, hasAccess]);

    return { fetchDataError, restrictedProfileData, isLoading };
};

export default useFetchICEData;
